import { css } from 'lit';
export default css `
    :host {
        --icon-background: transparent;

        display: inline-block;
        height: var(--icon-height);
        width: var(--icon-width);
    }

    :host([disabled]) {
        --icon-color: var(--color-ui-04);
    }

    :host([size='xs']) {
        --icon-height: var(--icon-size-xs);
        --icon-width: var(--icon-size-xs);
    }

    :host([size='s']) {
        --icon-height: var(--icon-size-s);
        --icon-width: var(--icon-size-s);
    }

    :host([size='m']) {
        --icon-height: var(--icon-size-m);
        --icon-width: var(--icon-size-m);
    }

    :host([size='l']) {
        --icon-height: var(--icon-size-l);
        --icon-width: var(--icon-size-l);
    }

    :host([size='xl']) {
        --icon-height: var(--icon-size-xl);
        --icon-width: var(--icon-size-xl);
    }

    :host([size='xxl']) {
        --icon-height: var(--icon-size-xxl);
        --icon-width: var(--icon-size-xxl);
    }

    :host([size='xxxl']) {
        --icon-height: var(--icon-size-xxxl);
        --icon-width: var(--icon-size-xxxl);
    }

    svg {
        display: inline-block;
        height: var(--icon-height);
        width: var(--icon-width);
        fill: var(--icon-color, var(--color-primary));
        transition: fill var(--icon-transition-speed, 0);
    }

    svg.fill-stroke {
        fill: none;
    }

    svg.fill-stroke > g,
    svg.fill-stroke path {
        stroke: var(--icon-color, var(--color-primary));
    }

    svg.fill > g,
    svg.fill path {
        fill: var(--icon-color, var(--color-primary));
    }

    svg.fill > g .fill-none,
    svg.fill path .fill-none {
        fill: none;
    }
`;
